import { render, staticRenderFns } from "./OrdersIncidentModal.vue?vue&type=template&id=c0fcd002&"
import script from "./OrdersIncidentModal.vue?vue&type=script&lang=js&"
export * from "./OrdersIncidentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports